import { Theme } from "@mui/material";

export const popUpMenuStyles = {
  iconButton: (theme: Theme) => ({
    width: 54,
    height: 54,
    [theme.breakpoints.down("lg")]: {
      padding: 0,
    },
  }),
};

